const AUTH_TOKEN_KEY = "TTT_AUTH_TOKEN";
const USER_KEY = "TTT_USER";

export function getAuthToken() {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY) || "";
  } catch (err) {
    console.error("Failed to read auth token:", err);
    return "";
  }
}

export function getCurrentUser() {
  try {
    const storedUser = localStorage.getItem(USER_KEY);

    if (!storedUser) {
      return null;
    }

    return JSON.parse(storedUser);
  } catch (err) {
    console.error("Failed to read current user:", err);
    return null;
  }
}

export function authHeaders() {
  const token = getAuthToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
}

export function isOwner() {
  return getCurrentUser()?.role === "owner";
}

export function isStaff() {
  return getCurrentUser()?.role === "staff";
}

export function clearAuth() {
  try {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  } catch (err) {
    console.error("Failed to clear authentication:", err);
  }
}

export function handleUnauthorized() {
  clearAuth();
  window.location.replace("/login");
}
